module.exports = __webpack_public_path__ + "static/img/1.4ca1369.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/management/1.png
// module id = BxuI
// module chunks = 7